window._ = require('lodash');

try {
    window.$ = window.jQuery = require('jquery');
    window.Popper = require('popper.js').default;
    require('bootstrap');
} catch (e) {
    //
}

//require('@fortawesome/fontawesome-pro/js/all');
//require('select2');
require('bootstrap-select');

import $ from 'jquery';

$(() => {
    //$('.select2').select2();

    $("#menu-toggle").click(function (e) {
        e.preventDefault();
        $("#wrapper").toggleClass("toggled");
    });

    $(function () {
        $('[data-toggle="tooltip"]').tooltip();
        $('select').selectpicker();
      });
});

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
